import React, { Component } from 'react'
import IrregularInteraction from '../IrregularInteraction'
import ItemImageAnimated from '../ItemImageAnimated'
import Frame1Image from '../../assets/images/item--blinds--f1@3x.png'
import Frame2Image from '../../assets/images/item--blinds--f2@3x.png'
import Frame3Image from '../../assets/images/item--blinds--f3@3x.png'
import Frame4Image from '../../assets/images/item--blinds--f4@3x.png'
import Frame5Image from '../../assets/images/item--blinds--f5@3x.png'

const points =
  '169.97 94.8 170 94.78 5.7 0 0 3.5 0 10.57 3.88 12.8 3.88 43.09 3.96 43.13 3.96 204.69 7.69 206.84 7.69 209.91 10.91 209.91 10.91 211.75 14.12 211.75 14.12 213.6 17.34 213.6 17.34 215.45 20.56 215.45 20.56 217.3 23.77 217.3 23.77 219.14 26.99 219.14 26.99 220.99 30.21 220.99 30.21 222.84 33.43 222.84 33.43 224.68 36.64 224.68 36.64 226.53 39.86 226.53 39.86 228.38 43.08 228.38 43.08 230.22 46.3 230.22 46.3 232.07 49.51 232.07 49.51 233.92 52.73 233.92 52.73 235.77 55.95 235.77 55.95 237.61 64.76 237.61 65.42 237.61 70.63 240.62 70.63 240.62 80.25 246.17 80.25 246.17 162.13 293.41 162.13 295.94 168.24 299.47 170 298.45 170 94.93 169.97 94.91 169.97 94.8'

const frames = [Frame1Image, Frame2Image, Frame3Image, Frame4Image, Frame5Image]

export default class Blinds extends Component {
  static propTypes = IrregularInteraction.propTypes

  constructor(props) {
    super(props)

    this.state = {
      animate: props.animate,
    }
  }

  componentWillReceiveProps(nextProps) {
    const { animate, didAnimateOnce } = this.state

    if (!animate && nextProps.animate) {
      this.setState({ animate: true })
    }
  }

  render() {
    const { animate } = this.state

    return (
      <IrregularInteraction
        points={points}
        preserveAspectRatio="xMidYMin meet"
        viewBox="0 0 170 299.47"
        sparksTop={5}
        sparksLeft={100}
        sparksRotation={250}
        {...this.props}
      >
        <ItemImageAnimated
          srcs={frames}
          fps={6}
          animate={animate}
          onCompleteFrame={frames.length - 1}
          loops={1}
        />
      </IrregularInteraction>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/items/Blinds.js